module.exports = __webpack_public_path__ + "img/44_35.7d852d97.png";